export default __webpack_public_path__ + "static/media/btn-right.798ce1c6.svg";